var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import query from 'syf-component-library/const/mediaQueries';
import RenderIf from 'syf-component-library/ui/atoms/RenderIf';
import Inset from 'syf-component-library/ui/spacing/Inset';
import Stack from 'syf-component-library/ui/spacing/Stack';
import useMediaQuery from '../../../hooks/use-media-query';
import useRadioGroupFocusRef from '../../../hooks/use-radio-group-focus-ref';
import useTranslation from '../../../hooks/use-translation';
import Balance from '../../common/Balance';
import PaymentOptionsBanner from '../../common/PaymentOptionsBanner';
import RadioOptionCard from '../../common/RadioOptionCard';
import { StyledFlex } from '../../subcomponents';
import Installments from '../Installments';
import { StyledPaymentPlans, StyledPlanDisclosure } from '../subcomponents';
import useTriggerAnalyticsEvent from '../../../helpers/triggerAnalyticsEvent';
import { Routes } from '../../../const';
var SettlementOptions = function (_a) {
    var _b;
    var settlement = _a.settlement;
    var i18n = useTranslation();
    var isMobile = useMediaQuery(query.lessThanSmall);
    var _c = useState(''), checkedOption = _c[0], setCheckedOption = _c[1];
    var radioGroupRef = useRadioGroupFocusRef();
    var data = settlement.data, setPlan = settlement.setPlan;
    useTriggerAnalyticsEvent({
        featureEvent: 'settlementOptions',
        currentRoute: Routes.SETTLEMENT_OPTIONS
    });
    var onChange = function (planName) {
        var _a;
        setCheckedOption(planName);
        var chosenPlan = (_a = data === null || data === void 0 ? void 0 : data.paymentPlans) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
            var chosenPlanName = _a.planName;
            return chosenPlanName === planName;
        });
        setPlan(chosenPlan);
    };
    return (_jsxs(_Fragment, { children: [_jsx(PaymentOptionsBanner, {}), _jsx(Inset, __assign({ vertical: "base" }, { children: _jsxs(StyledFlex, __assign({ direction: "column", alignItems: "center", justifyContent: "center" }, { children: [_jsx(Stack, { size: isMobile ? 'large' : 'xlarge' }), _jsx(StyledPlanDisclosure, __assign({ weight: "bold", align: "center" }, { children: i18n('settlement.planDisclosureText') })), _jsx(Stack, { size: isMobile ? 'base' : 'large' }), _jsx(Balance, { settlementResponseData: data }), _jsx(Stack, { size: "large" }), _jsx(StyledPaymentPlans, __assign({ ref: radioGroupRef }, { children: (_b = data === null || data === void 0 ? void 0 : data.paymentPlans) === null || _b === void 0 ? void 0 : _b.map(function (paymentPlan) {
                                var _a, _b;
                                return (_jsxs("div", { children: [_jsx(RadioOptionCard, { checked: checkedOption === paymentPlan.planName, id: paymentPlan.planName, name: "dch-settlement-payment-plan", title: "".concat((_a = paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.installments) === null || _a === void 0 ? void 0 : _a.length, " ").concat(((_b = paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.installments) === null || _b === void 0 ? void 0 : _b.length) === 1
                                                ? i18n('settlement.cardDetailsPaymentText')
                                                : i18n('settlement.cardDetailsPaymentsText')), value: paymentPlan.planName, onChange: onChange, body: _jsx(Installments, { installments: paymentPlan.installments }) }), _jsx(Stack, { size: "base" })] }, paymentPlan.planName));
                            }) })), _jsx(RenderIf, __assign({ condition: !isMobile }, { children: _jsx(Stack, { size: "base" }) }))] })) }))] }));
};
export default SettlementOptions;
//# sourceMappingURL=index.js.map